import React, { Component } from 'react';
import $ from "jquery";
import axios from 'axios';
class EmploymentDetails extends Component {
  constructor() {
    super();
    this.state = {
      submit_button:<button className="btn btn-primary w-100 py-3" type="button" onClick={this.add_emp_basic_details.bind(this)}>Update</button>,
    };
  }


  componentDidMount(){
    this.get_emp_basic_details();
  }
  get_emp_basic_details(){
      var cutThis           = this;
      var emp_id            = cutThis.props.id;
      var web_token         = window.isNullAndUndef($('#web_token').val());
      var body = new FormData();
      body.append('emp_id',emp_id);
      body.append('web_token',web_token);
      body.append('form_type','employee_employment_details');
      body.append('function','get_emp_basic_details');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/admin_employee_management_url.php";
      }else{
        url = "/php/admin_employee_management_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           data: body
       })
       .then(function (res) {
          var data = res.data;
          if(data['error']==1){
            var new_data = data['data'];
            cutThis.update_info(new_data);
          }

       })
       .catch(function (error) {
           console.log(error);
       });
  }

  update_info(data){
    $('#employee_code ').val(data['employee_code']);
    $('#designation').val(data['designation']);
    $('#department').val(data['department']);
    $('#date_of_joining').val(data['date_of_joining']);
    $('#employment_type').val(data['employment_type']);
    $('#work_location').val(data['work_location']);
    $('#reporting_manager').val(data['reporting_manager']);
    $('#confirmation_date').val(data['confirmation_date']);
    $('#last_working_date').val(data['last_working_date']);
  }

  add_emp_basic_details(){
    var cutThis           = this;
    var emp_id            = cutThis.props.id;
    var web_token         = window.isNullAndUndef($('#web_token').val());
    var employee_code     = window.isNullAndUndef($('#employee_code').val());
    var designation       = window.isNullAndUndef($('#designation').val());
    var department        = window.isNullAndUndef($('#department').val());
    var date_of_joining   = window.isNullAndUndef($('#date_of_joining').val());
    var employment_type   = window.isNullAndUndef($('#employment_type').val());
    var work_location     = window.isNullAndUndef($('#work_location').val());
    var reporting_manager = window.isNullAndUndef($('#reporting_manager').val());
    var confirmation_date = window.isNullAndUndef($('#confirmation_date').val());
    var last_working_date = window.isNullAndUndef($('#last_working_date').val());


    var submit_button     = <button className="btn btn-primary w-100 py-3" type="button">Update...</button>;
    cutThis.setState({submit_button});
    $('label').removeClass('color_red');
    if(employee_code && designation && department && date_of_joining && employment_type && work_location && reporting_manager && confirmation_date){
      var all_data                    = {};
      all_data['employee_code']       = employee_code;
      all_data['designation']         = designation;
      all_data['department']          = department;
      all_data['date_of_joining']     = date_of_joining;
      all_data['employment_type']     = employment_type;
      all_data['work_location']       = work_location;
      all_data['reporting_manager']   = reporting_manager;
      all_data['confirmation_date']   = confirmation_date;
      all_data['last_working_date']   = last_working_date;
      var body = new FormData();
      body.append('emp_id',emp_id);
      body.append('emp_date',JSON.stringify(all_data));
      body.append('web_token',web_token);
      body.append('form_type','employee_employment_details');
      body.append('function','add_emp_basic_details');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/admin_employee_management_url.php";
      }else{
        url = "/php/admin_employee_management_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           data: body
       })
       .then(function (res) {
          var data = res.data;
          $('#error_msg').text(data['msg']);
          submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_emp_basic_details.bind(cutThis)}>Update</button>;
          cutThis.setState({submit_button});
       })
       .catch(function (error) {
           console.log(error);
       });
    }else {
      window.change_lable_color('employee_code','designation','department','date_of_joining','employment_type','work_location','reporting_manager','confirmation_date');
      submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_emp_basic_details.bind(cutThis)}>Update</button>;
      cutThis.setState({submit_button});
    }

  }


  render() {
    return (
        <>
        	<div className="mt-4 mb-4">
                <h3 className="wow fadeInUp" data-wow-delay="0.1s">{this.props.page_title}</h3>
                <div className="row g-4">


                <div className="col-md-12">
                    <div className="wow fadeInUp" data-wow-delay="0.5s">
                        <form action="" method="post">
                            <div className="row g-3">

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="employee_code" placeholder="Employee Code"/>
                                        <label for="name">Employee Code</label>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="designation" placeholder="Designation"/>
                                        <label for="name">Designation</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="department" placeholder="Department"/>
                                        <label for="name">Department</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="date" className="form-control" id="date_of_joining" placeholder="Date of Joining"/>
                                        <label for="name">Date of Joining</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <select class="form-control form-select" id="employment_type" name="form_type">
                                        <option value="">Employment Type</option>
                                        <option value="Permanent">Permanent</option>
                                        <option value="Temporary">Temporary</option>
                                        <option value="Intern">Intern</option>
                                        <option value="Contractual">Contractual</option>
                                    </select>
                                    <label for="name">Employment Type</label>
                                    </div>
                                </div>


                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="work_location" placeholder="Work Location"/>
                                        <label for="name">Work Location</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="reporting_manager" placeholder="Reporting Manager"/>
                                        <label for="name">Reporting Manager</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="date" className="form-control" id="confirmation_date" placeholder="Confirmation Date"/>
                                        <label for="name">Confirmation Date</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="date" className="form-control" id="last_working_date" placeholder="Last Working Date"/>
                                        <label for="name">Last Working Date</label>
                                    </div>
                                </div>


                                <div className="col-md-12">
                                  <div className="col-md-8">
                                    <p id="error_msg"></p>
                                  </div>
                                  <div className="col-md-4 p-0 float_r">
                                      {this.state.submit_button}
                                  </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

            </div>
        </div>

        </>
    );
  }
}

export default EmploymentDetails;
